import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getCategoryConfigurationById = createAsyncThunk(
  "category/getCategoryConfigurationById",
  async (payload) => {
    try {
      const response = await magnifiAPI.getCategoryConfigurationById(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const addCategoryConfiguration = createAsyncThunk("category/addCategoryConfiguration", async (payload) => {
  try {
    const response = await magnifiAPI.addCategoryConfiguration(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateCategoryConfiguration = createAsyncThunk("category/updateCategoryConfiguration", async (payload) => {
  try {
    const response = await magnifiAPI.updateCategoryConfiguration(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteCategoryConfiguration = createAsyncThunk("category/deleteCategoryConfiguration", async (payload) => {
  try {
    const response = await magnifiAPI.deleteCategoryConfiguration(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
